@let isValid = formValid() || currentStepValid();

<div #wizardScrollAnchor></div>
<div class="wizard__container">
  <app-wizard-progress
    class="wizard__top"
    [steps]="steps()"
    [currentStepNumber]="currentStepNumber()"
    (selectStep)="select($event)"
    appElevation
    [elevation]="floatingTop() ? 3 : null"
  ></app-wizard-progress>

  <div class="wizard__step-container" [class.container]="wrapStepContainer()">
    <ng-content select="app-profile-dk-explanation"></ng-content>
  </div>

  @for (template of stepTemplates(); track template; let stepIndex = $index) {
    <div class="wizard__step-container" [class.container]="wrapStepContainer()">
      @if (currentStepNumber() === stepIndex + 1) {
        <ng-container
          [ngTemplateOutlet]="template"
          [ngTemplateOutletContext]="{ $implicit: stepChange }"
        ></ng-container>
      }
    </div>
  }
  @if (!hideButtonContainer() && viewLoaded()) {
    <div
      class="wizard__actions-container"
      [class.wizard__actions-container--floating]="floatingActions()"
      appElevation
      [elevation]="floatingActions() ? 3 : null"
    >
      <div class="container-fluid wizard__footer">
        <app-wizard-progress
          class="wizard__bottom"
          [steps]="steps()"
          [currentStepNumber]="currentStepNumber()"
          (selectStep)="select($event)"
        ></app-wizard-progress>
        <ng-content select="[wizard-footer]"></ng-content>
        <div
          class="wizard__actions-buttons d-flex justify-content-end align-items-end"
          [class.pe-0]="!floatingActions()"
        >
          @if (
            allowCancel() &&
            (currentStepNumber() === 1 || allowCancelInAnyStep())
          ) {
            <button
              im-button
              class="inverted"
              [disabled]="isProcessing()"
              (click)="cancel()"
            >
              {{ 'general.cancel_a' | translate }}
            </button>
          }
          @if (allowBack() && currentStepNumber() > 1) {
            <button
              im-button
              class="inverted me-1"
              [disabled]="isProcessing()"
              (click)="back()"
            >
              {{ 'general.previous_a' | translate }}
            </button>
          }
          @let buttonDisabled =
            alwaysEnableButton() ? false : !isValid || isProcessing();
          @if (currentStepNumber() < steps().length && !hideNextButton()) {
            <button
              im-button
              class="primary"
              [disabled]="buttonDisabled || isProcessing()"
              id="next-btn"
              (click)="next()"
            >
              @if (isProcessing()) {
                <im-spinner iconStart class="sm" />
              }
              {{ 'general.next_a' | translate }}
            </button>
          }
          @if (currentStepNumber() === steps().length) {
            <button
              im-button
              class="primary"
              [disabled]="buttonDisabled || isProcessing()"
              id="save-btn"
              (click)="complete()"
            >
              @if (isProcessing()) {
                <im-spinner iconStart class="sm" />
              }
              {{ 'general.complete_a' | translate }}
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>
